import WebinaritemScreen from './containers/webinaritemScreen'

export {default as WebinaritemScreenLayout} from './components/webinaritemScreenLayout'

export default WebinaritemScreen
